// extracted by mini-css-extract-plugin
export var linkText = "_ml-0";